import { apiRequest } from "@/lib/api";

export interface AdminSubscription {
  id: string;
  teamId: string;
  teamName: string | null;
  plan: string;
  status: string;
  currentPeriodStart: string | null;
  currentPeriodEnd: string | null;
  lastPaymentAt: string | null;
  nextDunningAt: string | null;
  createdAt: string;
}

export interface PaginatedAdminSubscriptions {
  subscriptions: AdminSubscription[];
  pagination: { total: number; page: number; pageSize: number; pageCount: number };
}

export interface ListSubscriptionsParams {
  status?: string;
  page?: number;
  pageSize?: number;
}

export function listSubscriptions(
  params: ListSubscriptionsParams,
): Promise<PaginatedAdminSubscriptions> {
  return apiRequest("/api/admin/subscriptions", {
    query: params as Record<string, unknown>,
  });
}